import COS from "cos-js-sdk-v5";
import {getCosTempToken} from "@/api";

// 处理base64格式的文件体，便于上传文件(不使用此函数转译base64就会将base64字符串保存为文件，不能获得真实图片)
let dataURLtoBlob = function (dataurl) {
  // console.log(dataurl);
  let arr = dataurl.split(",");
  let mime = arr[0].match(/:(.*?);/)[1];
  let bstr = atob(arr[1]);
  let n = bstr.length;
  let u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], {type: mime});
};

// 生成唯一的图片名
export function createUpPosImgName() {
  let openId = sessionStorage.getItem("openid");
  let DateNow = new Date().getTime();
  return openId + "_" + DateNow + "." + "png";
}

//网点资料采集图片（图片上传）
const getCosByPath = function (path) {
  let cos = new COS({
    getAuthorization: function (options, callback) {
      getCosTempToken(path).then((res) => {
        console.log("获取costoken响应拦截", res.data);
        if (res.data.retcode == 0) {
          let data = res.data.data;
          callback({
            TmpSecretId: data.tmpSecretId,
            TmpSecretKey: data.tmpSecretKey,
            SecurityToken: data.sessionToken,
            ExpiredTime: data.expiredTime,
            PathPre: data.pathPre,
          });
          console.log("请求token时的文件地址", data.pathPre);
          sessionStorage.setItem(`${path}_cosPath`, data.pathPre);
          console.log(
            "从session中取出来的文件目录为",
            sessionStorage.getItem(`${path}_cosPath`)
          );
        }
      });
    },
  });
  return cos;
};

// 保存网点资料采集上传的图片url
export function getCOSUrlByPath(name, path) {
  let cosPath = sessionStorage.getItem(`${path}_cosPath`);
  console.log("命名时的文件名", cosPath);
  let bashUrl = `https://washshare-1256601262.cos.ap-guangzhou.myqcloud.com/${cosPath}/`;
  return bashUrl + name;
}

//图片上传的功能
export function uploadImage(fileObj, imgName, path, callbackFunc) {
  return new Promise((resolve, reject) => {
    let file = dataURLtoBlob(fileObj);
    // console.log("uploadImg()中的图片地址", imgName);
    // console.log("存图片前的图片目录", sessionStorage.getItem(`${path}_cosPath`));
    getCosByPath(path).putObject(
      {
        Bucket: "washshare-1256601262",
        Region: "ap-guangzhou",
        Key: sessionStorage.getItem(`${path}_cosPath`) + "/" + imgName,
        Body: file,
        onProgress: function (pd) {
          // console.log(JSON.stringify(pd));
        },
      },
      function (err, data) {
        console.log(err || data);
        if (data.statusCode == 200) {
          resolve(getCOSUrlByPath(imgName, path));
          // callbackFunc(getCOSUrlByPath(imgName, path));
        } else {
          reject(err);
        }
      }
    );
  })
}



// WEBPACK FOOTER //
// ./src/util/material_uploadImage.js